import React from "react";
import { makeStyles } from "@mui/styles";
import { HeaderMenu } from "../components/Header";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";
import { Typography } from "../components/Typography";
import sssintro from "../asset/3sintro.png";
import halfCircleBlue from "../asset/half_circle_blue.png";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "auto",
    },
  },
  body: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignSelf: "center",
    height: "100vh",
    minHeight: 815,
    justifyContent: "center",
    alignItems: "center",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      margin: "12px 20px",
      borderTop: "none",
    },
  },
  container1: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    marginTop: 50,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
    },
  },
  top_text: {
    position: "relative",
    display: "flex",
    justifyContent: "left",
    color: "#204FA1",
    maxWidth: 1290,
    fontSize: 18,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: 18,
      marginTop: 0,
      marginLeft: 50,
      justifyContent: "flex-start",
    },
  },
  textBox1: {
    width: 628,
    alignSelf: "center",
    position: "relative",
    marginTop: 20,
    marginBottom: 20,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      marginTop: 20,
      marginBottom: 20,
      textAlign: "justify",
    },
  },
  subtextBox: {
    wordBreak: "break-word",
    textAlign: "justify",
    width: 634,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      margin: "12px 20px",
      width: "auto",
    },
  },
  imgBox: {
    position: "relative",
    margin: "50px 0px",
    textAlign: "center",
    background: "#fdf5fd",
    width: "100%",
    height: 470,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      height: "auto",
    },
  },
  img: {
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "80%",
      margin: "10px",
    },
  },
  halfCircleBlue: {
    position: "relative",
    bottom: 5,
    right: 30,
    width: 65,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
      bottom: 5,
      marginLeft: 20,
    },
  },
}));

const SSSBisIntroPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.textBox1}>
          <img
            src={halfCircleBlue}
            alt="blueHalfCircle"
            className={classes.halfCircleBlue}
          />
          <Typography variant="H3" className={classes.top_text}>
            사업소개
          </Typography>
        </div>

        <div className={classes.subtextBox}>
          <Typography variant="mbaContent">
            3S-BIS는 방문간호센터의 경영 개선을 지원하기 위한 목적으로 경영
            성과의 핵심 요소인 CVP (Cost-Volume-Profit)에 기반하여 인사관리,
            재고관리, 운영관리를 통합하고 이를 수익관리, 비용관리, 이익관리의
            경영 목적에 따라 data managing, analysis, integration 하는 ERP 경영
            솔루션입니다.
            <br />
            <br />
            3S-BIS에 내재되는 3S는 (1) 분절화된 자료를 종합하여 경영 목적 달성에
            필요한 정보를 automatically produce하는 기능적 관점에서의 Smart (2)
            방문간호센터의 특성 상 주요 활동이 센터 밖에서 이루어지는 점을
            반영하여 현장에서 smart phone App.을 통해 즉시 자료를 송부하거나
            분석 결과를 확인하는 과정적 관점에서의 Speed (3) 최소 자료 입력과
            automatic calculation으로 user friendly형으로 운영되는 이용자
            관점에서의 Simple의 ERP 시스템입니다.
          </Typography>
        </div>

        <div className={classes.imgBox} style={{}}>
          <img src={sssintro} alt="3sintro" className={classes.img}></img>
        </div>
      </div>

      <Footer />
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};

export default SSSBisIntroPage;
